'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = undefined;

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../../identifiers');

var _Column = require('./Column');

var _style = require('./../style.helper');

var ThemedColumn = (0, _reactCssThemr.themr)(_identifiers.GRID_COLUMN, _style.defaultTheme)(_Column.Column);
exports['default'] = ThemedColumn;
exports.Column = ThemedColumn;